// Import all views here
import galleryView from './views/GalleryView';
import PosterGeneratorView from './views/PosterGeneratorView';
import HomeView from './views/HomeView';

export default [galleryView, PosterGeneratorView, HomeView];
